/**
 * Super class of all renderers
 */
define("tmds/renderers/Renderer", [
], function() {
	"use strict";
	
	var Renderer = function() {};
	
	/**
	 * convert Renderer object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type
		};
	}
	
	Renderer.prototype = {
		declaredClass: "tmds.renderers.Renderer",
		type: "Renderer",
		'toJson' : toJson
	};
	
	return Renderer;
});